var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnInspection = function SvgIcnInspection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_28755)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2031_28755)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54003 2.53955C2.95678 2.1228 3.52201 1.88867 4.11138 1.88867H5.66694C6.03513 1.88867 6.33361 2.18715 6.33361 2.55534C6.33361 2.92353 6.03513 3.22201 5.66694 3.22201H4.11138C3.87563 3.22201 3.64954 3.31566 3.48284 3.48235C3.31614 3.64905 3.22249 3.87515 3.22249 4.11089V13.4442C3.22249 13.68 3.31614 13.9061 3.48284 14.0728C3.64954 14.2395 3.87563 14.3331 4.11138 14.3331H11.8892C12.1249 14.3331 12.351 14.2395 12.5177 14.0728C12.6844 13.9061 12.778 13.68 12.778 13.4442V4.11089C12.778 3.87515 12.6844 3.64905 12.5177 3.48235C12.351 3.31566 12.1249 3.22201 11.8892 3.22201H10.3336C9.96542 3.22201 9.66694 2.92353 9.66694 2.55534C9.66694 2.18715 9.96542 1.88867 10.3336 1.88867H11.8892C12.4785 1.88867 13.0438 2.1228 13.4605 2.53955C13.8773 2.95629 14.1114 3.52152 14.1114 4.11089V13.4442C14.1114 14.0336 13.8773 14.5988 13.4605 15.0156C13.0438 15.4323 12.4785 15.6664 11.8892 15.6664H4.11138C3.52201 15.6664 2.95678 15.4323 2.54003 15.0156C2.12329 14.5988 1.88916 14.0336 1.88916 13.4442V4.11089C1.88916 3.52152 2.12329 2.95629 2.54003 2.53955Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22222 1.66683C6.98647 1.66683 6.76038 1.76048 6.59368 1.92718C6.42698 2.09388 6.33333 2.31997 6.33333 2.55572C6.33333 2.79147 6.42698 3.01756 6.59368 3.18426C6.76038 3.35096 6.98647 3.44461 7.22222 3.44461H8.77778C9.01353 3.44461 9.23962 3.35096 9.40632 3.18426C9.57302 3.01756 9.66667 2.79147 9.66667 2.55572C9.66667 2.31997 9.57302 2.09388 9.40632 1.92718C9.23962 1.76048 9.01353 1.66683 8.77778 1.66683H7.22222ZM5.65087 0.98437C6.06762 0.567622 6.63285 0.333496 7.22222 0.333496H8.77778C9.36715 0.333496 9.93238 0.567622 10.3491 0.98437C10.7659 1.40112 11 1.96635 11 2.55572C11 3.14509 10.7659 3.71032 10.3491 4.12707C9.93238 4.54381 9.36715 4.77794 8.77778 4.77794H7.22222C6.63285 4.77794 6.06762 4.54381 5.65087 4.12707C5.23413 3.71032 5 3.14509 5 2.55572C5 1.96635 5.23413 1.40112 5.65087 0.98437Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8047 7.52876C11.0651 7.78911 11.0651 8.21122 10.8047 8.47157L7.69363 11.5827C7.43328 11.843 7.01117 11.843 6.75082 11.5827L5.19526 10.0271C4.93491 9.76677 4.93491 9.34466 5.19526 9.08431C5.45561 8.82396 5.87772 8.82396 6.13807 9.08431L7.22222 10.1685L9.86193 7.52876C10.1223 7.26841 10.5444 7.26841 10.8047 7.52876Z",
    fill: "currentcolor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_28755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2031_28755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 16,
    fill: "white",
    transform: "translate(1.3335)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnInspection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_inspection.3451c636.svg";
export { ForwardRef as ReactComponent };